const GetCategoryProperty = (value) => {
    let result = {
        summaryDescription:'',
        summaryImage:'',
        educationImage:'',
        description:'',
        image:'',
        lessonCount:'',
        isVideo:false,
        isListen:false,
        isQuiz:false,
        isWord:false,
        level:[],
        packageId:'',
        packageWeeklyDay:[],
        packageDuration:[],
        packageMonth:[]
    };
    if(value){
        const educationImage = FindKeyInProperty(value, 'EducationImage');
        if (educationImage != null)
            result.educationImage = educationImage;

        let summaryDescription = FindKeyInProperty(value,'SummaryDescription');
        if(summaryDescription!=null)
            result.summaryDescription = summaryDescription;

        let summaryImage = FindKeyInProperty(value,'SummaryImage');
        if(summaryImage!=null)
            result.summaryImage = summaryImage;

        let description = FindKeyInProperty(value,'Description');
        if(description!=null)
            result.description = description;

        let image = FindKeyInProperty(value,'Image');
        if(image!=null)
            result.image = image;

        let lessonCount = FindKeyInProperty(value,'LessonCount');
        if(lessonCount!=null)
            result.lessonCount = lessonCount;


        let isVideo = FindKeyInProperty(value,'IsVideo');
        if(isVideo!=null)
            result.isVideo = isVideo=='true';

        let isListen = FindKeyInProperty(value,'IsListen');
        if(isListen!=null)
            result.isListen = isListen=='true';

        let isQuiz = FindKeyInProperty(value,'IsQuiz');
        if(isQuiz!=null)
            result.isQuiz = isQuiz=='true';

        let isWord = FindKeyInProperty(value,'IsWord');
        if(isWord!=null)
            result.isWord = isWord=='true';

        let level = FindKeyInProperty(value,'Level');
        if(level!=null)
            result.level = level.split(',');

        let packageId = FindKeyInProperty(value,'PackageId');
        if(packageId!=null)
            result.packageId = lessonCount;

        let packageWeeklyDay = FindKeyInProperty(value,'PackageWeeklyDay');
        if(packageWeeklyDay!=null)
            result.packageWeeklyDay = packageWeeklyDay.split(',');

        let packageDuration = FindKeyInProperty(value,'PackageDuration');
        if(packageDuration!=null)
            result.packageDuration = packageDuration.split(',');

        let packageMonth = FindKeyInProperty(value,'PackageMonth');
        if(packageMonth!=null)
            result.packageMonth = packageMonth.split(',');
    }
    return result
}

const FindKeyInProperty = (properties,key)=>{
    let data = properties.find(x=>x.key==key);
    if(data){
        if(data.value!=''){
            return data.value;
        }
    }
    return null;
}

export { GetCategoryProperty }
